import './localHistoryCommands.js';
import { registerWorkbenchContribution2 } from 'vscode/vscode/vs/workbench/common/contributions';
import { LocalHistoryTimeline } from './localHistoryTimeline.js';

registerWorkbenchContribution2(LocalHistoryTimeline.ID, LocalHistoryTimeline, 2 );
